module.exports = __webpack_public_path__ + "media/PaperClipIcon.09ba3154.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/icons/PaperClipIcon.svg
// module id = 764
// module chunks = 0